import { useSearchParams } from "react-router-dom";
import Seo, { breadcrumbs } from "../components/Seo";
import LeadForm from "../components/LeadForm";
import { SectionHeader } from "../components/UI";

export default function ScheduleTestDrive() {
  const [sp] = useSearchParams();
  const vin = sp.get("vin") || "";
  const stock = sp.get("stock") || "";
  const title = sp.get("title") || "";

  return (
    <main id="main-content">
      <Seo
        title="Schedule a Test Drive | Scott Sells Chevys"
        description="Request a test drive time with Scott for a new or used vehicle in Central Ohio."
        canonicalPath="/schedule-test-drive"
        jsonLd={[breadcrumbs([{ name: "Home", path: "/" }, { name: "Schedule Test Drive", path: "/schedule-test-drive" }])]}
      />
      <section className="ssc-hero">
        <div className="ssc-container py-10 md:py-16">
          <h1 className="ssc-display text-3xl md:text-5xl font-extrabold">Request a Test Drive</h1>
          <p className="mt-3 text-[var(--ssc-silver)]">I'll confirm availability and follow up with the best time.</p>
        </div>
      </section>
      <section className="ssc-section">
        <div className="ssc-container max-w-2xl">
          <SectionHeader title="Tell me when works for you" />
          <LeadForm
            leadType="test_drive"
            leadSource="Schedule Test Drive Page"
            testIdPrefix="td-lead"
            fields={[
              { name: "name", label: "Name", required: true, autoComplete: "name" },
              { name: "phone", label: "Phone", inputMode: "tel", autoComplete: "tel" },
              { name: "email", label: "Email", type: "email", autoComplete: "email" },
              { name: "vehicle_of_interest", label: "Vehicle of Interest", placeholder: title || "Year/Make/Model/Trim" },
              { name: "preferred_day", label: "Preferred Day" },
              { name: "preferred_time", label: "Preferred Time", type: "select", options: ["Morning", "Afternoon", "Evening", "Anytime"] },
              { name: "trade_in", label: "Trade-In?", type: "select", options: ["Yes", "No"] },
              { name: "message", label: "Message", type: "textarea", full: true },
            ]}
            hidden={{ vehicle_title: title, vin, stock_number: stock }}
            submitLabel="Request Test Drive Time"
            successMessage="Thanks. I'll check availability and follow up to confirm the best time."
          />
        </div>
      </section>
    </main>
  );
}
